<template>
    <!-- 登录频次 -->
    <div class="col-chart-box">
        <div class="col-chart-head line">
            <div class="left">
                <div class="left-title">登录频次</div>
                <el-popover :content="content" placement="right" trigger="hover" width="300" >
                    <i slot="reference" class="iconfont icon-icon-zhuming2"></i>
                </el-popover>
            </div>
        </div>
        
        <div v-loading="loading"  class="col-chart-view" style="display: flex;justify-content: center;">
            <div ref="loginRateEchart" style="height: 258px; width:100%"></div>
        </div>
         <!-- <div style="margin-top:100px" v-else>
            <NoDataAutoHeight/>
        </div> -->
    </div>
</template>

<script>
import windowAddEvent from '@/utils/windowAddEvents';
import {  getDataAssistant } from "@/utils/api/dashboard";
import NoDataAutoHeight from '@/components/NoData-autoHeight.vue';

export default  {
    props:{
        startTime:{
            typeof: String,
            default: ''
        },
        endTime:{
            typeof: String,
            default: ''
        },
        days:{
            typeof: Number,
            default: 0 
        }
    },
    components: {
        NoDataAutoHeight
    },
    data(){
        return {
            content:  '通过电脑端、H5端或小程序端主动登录海智平台次数（如设置90天内免登录，则其免登录情况将无法统计；小程序绑定账号计为1次登录，登录状态直接访问小程序的登录情况目前无法从微信平台获取）',
            echartsObj: '',
            loginNumData:{},
            loading : false,
        }
    },
    watch: {
        startTime: {
            handler(newVal) {
                if(newVal) {
                    this.getLoginNumData()
                }
            },
        },
        // days:{
        //     handler(newVal) {
        //         if(newVal) {
        //             console.log('监听天数',newVal);
        //             this.days = newVal
        //         }
        //     },
        //     deep:true,
        //     immediate:true
        // }
    },
    methods:{
        //获取数据
        getLoginNumData(){
            this.loading = true;
            const params = {
                startDate: this.startTime,
                endDate: this.endTime,
                enums:['LOGIN_NUM']
            }
            getDataAssistant(params)
            .then((res)=>{
                const bizCode = res.rspResult.bizCode;
                const codeArr = [401, 403, 404];
                if(bizCode === 200){
                    this.loginNumData = res.data || {};
                    this.addListData();
                    this.loading = false;
                }else if (!codeArr.includes(bizCode)) {
                    this.loading = false;
                    this.$message.error(res.data.rspResult.message);
                }
            })
            .catch((err)=>{
                this.loading = false;
                this.$message.error("System error",err);
            })
        },
       

        init(currentData) {
            let interval= 0;
            if(this.days < 9){
                interval= 0;
            }
            if(8<this.days &&this.days < 15){
                interval = Math.floor(this.days/8 ) 
            }
            if(14 < this.days &&  this.days< 31){
                interval = Math.floor(this.days/10)   
            }
            if(30 < this.days &&  this.days< 91){
                interval = Math.floor((this.days-10)/10)   
            }
            if(90 <this.days &&this.days< 366){
                interval = Math.floor(this.days/12)
            }
            if(365 < this.days){
                interval = Math.floor(this.days/9) 
            }
            let options = {
                color: ["#3A69F4"],
                tooltip: {  },
                
                xAxis: {
                    type: "category",
                    data: currentData.xData,
                    axisTick: {
                        alignWithLabel: true
                    },
                    axisLine: {
                        lineStyle: {
                            color: "#ccc"
                        }
                    },
                    axisLabel: {
                        interval,
                        rotate: 50,
                        color: "#666",
                        fontSize: 10,
                        fontFamily: "PingFangSC-Medium",
                        lineHeight: 17
                    }
                },
                yAxis: {
                    type: "value",
                    axisLine: {
                        lineStyle: {
                            color: "#ccc"
                        }
                    },
                    axisLabel: {
                        formatter: (value, index)=> {
                            if(value.toString().indexOf('.') > -1) {
                                return "";
                            }
                            return value;
                        }
                    }
                },
                // dataZoom: {
                //     start: 4,
                //     type: "inside"
                // },
                grid: {
                    left: 40,
                    right: 35,
                    bottom: 58
                },
                legend: {
                    type: "plain", // 图列类型，默认为 'plain'
                    itemWidth: 10,
                    itemHeight: 10,
                    top: "14", // 图列相对容器的位置 top\bottom\left\right
                    left: "15",
                    selected: {
                        // '销量': true  // 图列选择，图形加载出来会显示选择的图列，默认为true
                    },
                    tooltip: {
                        // 图列提示框，默认不显示
                        show: true,
                        // color: "red"
                    },
                    data: [
                        // 图列内容
                        {
                            name: "登录次数", //必须要与series的name一致。
                            icon: "rect",
                            textStyle: {
                                color: "#666", // 单独设置某一个图列的颜色
                                fontSize: 12,
                                fontFamily: "PingFangSC-Regular",
                                lineHeight: 17,
                                // backgroundColor: "#fff", // 单独设置某一个图列的字体背景色
                            }
                        }
                    ]
                },
                series: [
                    {
                        name: "登录次数",
                        data: currentData.yData,
                        type: "bar",
                        // showBackground: false,
                        // barWidth: '60%' //宽度可以不要如果一个月30条数据的时候就为细一点
                    }
                ]
            }

            this.echartsObj.clear();
            this.echartsObj.setOption(options);
        },
        handleListData(list) {
            let tmp= {
                x: [],
                y: []
            }

            list.forEach((item) => {
                tmp.x.push(item.title);
                tmp.y.push(item.num);
            });
            return tmp;
        },
        addListData() {
            const handledData = this.handleListData(this.loginNumData.loginNum);
            this.init({
                xData: handledData.x,
                yData: handledData.y
            })
        },
    
    },
    mounted() {
        let ele = this.$refs.loginRateEchart;
        this.echartsObj = this.$echarts.init(ele);
        this.getLoginNumData()
        windowAddEvent('resize', this.echartsObj.resize);
        
    }
}
</script>

<style lang="scss" scoped>

</style>